const parseQueryString = () => {
  const { search } = window.location;
  const params = new URLSearchParams(search)
  const query = {}
  for (const key of params.keys()) {
    query[key] = params.get(key);
  }
  return query;
}

export const setTokenManually = async () => {
  const { setToken } = parseQueryString();
  if (setToken === 'true') {
    const token = prompt(
      'Please Provide the Token running the following command in your terminal and override with your token:',
      'ztoken token -t https://sandbox.identity.zalando.com/oauth2/token -p 810d1d00-4312-43e5-bd31-d8373fdd24c7 -a https://sandbox.identity.zalando.com/oauth2/authorize'
    );
    if (token) {
      await fetch('/', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {'token': token}, redirect: 'follow', referrer: 'no-referrer'}
      );
      window.location.href = '/';
    }
  }
};
